import React from 'react';
import { motion } from 'framer-motion';
export function Introduction() {
  return <section id="intro" className="py-12 md:py-24 relative overflow-hidden" style={{
    background: 'linear-gradient(135deg, #5B2C6F 0%, #7D3C98 40%, #27AE60 80%, #2ECC71 100%)'
  }} data-id="element-105">
      {/* Julienne cabbage texture pattern */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-106">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-107">
          <defs data-id="element-108">
            <pattern id="julienne-intro" x="0" y="0" width="60" height="60" patternUnits="userSpaceOnUse" patternTransform="rotate(-25)" data-id="element-109">
              <path d="M0 30 Q15 25, 30 30 T60 30" fill="none" stroke="#fff" strokeWidth="1.5" opacity="0.6" data-id="element-110" />
              <path d="M0 10 Q15 5, 30 10 T60 10" fill="none" stroke="#fff" strokeWidth="1" opacity="0.4" data-id="element-111" />
              <path d="M0 50 Q15 45, 30 50 T60 50" fill="none" stroke="#fff" strokeWidth="1" opacity="0.3" data-id="element-112" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#julienne-intro)" data-id="element-113" />
        </svg>
      </div>

      {/* Decorative blobs */}
      <div className="absolute top-0 left-1/4 w-64 h-64 bg-cabbage rounded-full blur-3xl opacity-30" data-id="element-114"></div>
      <div className="absolute bottom-0 right-1/4 w-48 h-48 bg-leaf-dark rounded-full blur-3xl opacity-15" data-id="element-115"></div>

      <div className="container mx-auto px-5 md:px-6 max-w-4xl text-center relative z-10" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.8
      }} data-id="element-117">
          <span className="text-leaf font-serif italic text-xl md:text-2xl mb-4 md:mb-6 block" data-id="element-118">
            Una colección sin igual
          </span>
          <p className="text-xl md:text-4xl font-serif text-white leading-relaxed" data-id="element-119">
            Esta guía reúne un total de{' '}
            <span className="text-gold-light font-bold" data-id="element-120">66 recetas</span>{' '}
            cuidadosamente seleccionadas, donde el repollo blanco y morado se
            convierten en protagonistas absolutos, combinando{' '}
            <span className="italic text-cream" data-id="element-121">
              nutrición, sabor y estética
            </span>{' '}
            en cada plato.
          </p>
          <div className="w-16 md:w-24 h-1 bg-gold mx-auto mt-8 md:mt-12 rounded-full" data-id="element-122"></div>
        </motion.div>
      </div>
    </section>;
}